<template>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>

    <site-modal ID="sessionConfirmModal" @closed="cancelModal">
      <template #header>
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-question-circle-fill"
            viewBox="0 0 16 16"
          >
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.496 6.033h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286a.237.237 0 0 0 .241.247zm2.325 6.443c.61 0 1.029-.394 1.029-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94 0 .533.425.927 1.01.927z"
            ></path>
          </svg>
          {{ modalTitle }}
        </h6>
      </template>
      <template #body>
        <validation-summery
          v-if="modalConfirmHasError"
          :errors="modalError"
        ></validation-summery>
        <p>{{ modalMessage }}</p>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded btn-blueSite"
            @click="confirmedModal"
          >
            <i class="fi fi-box-checked"></i>
            تایید
          </button>
          <button class="btn btn-sm rounded btn-blueSite" @click="cancelModal">
            <i class="fi fi-close"></i>
            انصراف
          </button>
        </div>
      </template>
    </site-modal>

    <site-modal ID="informationModal" @closed="closeInformationModal">
      <template #header>
        <h6>
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-info-square"
            viewBox="0 0 16 16"
          >
            <path
              d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
            ></path>
            <path
              d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
            ></path>
          </svg>
          راهنما
        </h6>
      </template>
      <template #body>
        <div>
          <p class="justified">
            <strong>راهنما 1)</strong>
            با توجه به اینکه جلسات اورژانسی خارج از برنامه کاری درمانگر برگزار
            می‌شود، تعرفه متفاوتی از جلسات عادی دارند.
          </p>
          <p class="justified">
            <strong>راهنما 2)</strong>
            به منظور سهولت در تخصیص جلسات اورژانسی، این نوع از جلسات صرفا بصورت
            «غیرحضوری» برگزار می‌شوند.
          </p>
          <p class="justified">
            <strong>راهنما 3)</strong>
            جلسات روانپزشکی و روان‌شناسی قابلیت تنظیم بصورت اورژانسی را دارند.
          </p>
          <p class="justified">
            <strong>راهنما 4)</strong>
            لغو و جابجایی جلسات عادی تنها 48 ساعت قبل از تاریخ و ساعت شروع جلسه
            مشاوره امکانپذیر است.
          </p>
          <p class="justified">
            <strong>راهنما 5)</strong>
            فقط جلساتی که قبل از 48 ساعت از تاریخ ثبت شده لغو شوند، امکان
            استرداد وجه را خواهند داشت. جهت انجام فرآیند استرداد وجه می‌بایست با
            شماره تلفن
            <a href="tel:۰۲۱۹۱۰۰۵۱۴۱" class="text-blueSite text-dashed"
              >۹۱۰۰۵۱۴۱-۰۲۱</a
            >
            تماس حاصل فرمایید.
          </p>
          <p class="justified">
            <strong>راهنما 6)</strong>
            جلسات اورژانسی امکان لغو یا جابجایی ندارند.
          </p>
        </div>
      </template>
      <template #footer>
        <div class="m-auto">
          <button
            class="btn btn-sm rounded btn-blueSite"
            @click="closeInformationModal"
          >
            <i class="fi fi-box-checked"></i>
            تایید
          </button>
        </div>
      </template>
    </site-modal>

    <div class="mt-2 text-secondary d-flex justify-content-end">
      <button
        class="btn btn-sm rounded btn-blueSite m-0"
        :class="isMobile ? ' p-1' : ''"
        @click="refreshButtonClick"
      >
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-arrow-repeat"
          viewBox="0 0 16 16"
        >
          <path
            d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"
          ></path>
          <path
            fill-rule="evenodd"
            d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
          ></path>
        </svg>
      </button>
      <a
        class="btn btn-sm rounded btn-danger m-0 animate-pulse"
        :class="isMobile ? ' p-1' : ''"
        @click="goToEmergancySession"
      >
        <!-- :href="`/panel/emergencySessionTab/${$store.getters.userPersonID}`" -->
        <i class="fi fi-support-1"></i>
        درخواست جلسه اورژانسی
      </a>

      <hr class="hr-right" />
    </div>
    <div
      class="row justify-content-center my-3 scrollable-vertical scrollable-styled-dark"
      :style="isMobile ? '' : 'max-height: 70vh'"
    >
      <div class="col-12 col-lg-11">
        <div
          class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
          v-for="item in sessionList"
          :key="item.id"
          :class="
            item.clientSessionType == 'Workshop' ? 'bg-success-light' : ''
          "
        >
          <div
            class="card-body"
            :class="{
              'p-1 ps-2':
                item.clientSessionType == 'Session' && showTherapistPrifile,
            }"
          >
            <div class="row position-relative align-items-center">
              <div
                class="col-3 col-sm-3 col-md-3 col-lg-2 text-center border-1 border-start"
                v-if="
                  item.clientSessionType == 'Session' && showTherapistPrifile
                "
              >
                <therapist-profile
                  :ID="item.therapistID"
                  :therapistName="item.therapist"
                  tharpistNameClass="small fw-bold"
                  :psychology-organization-link="item.pschologyOrganizationLink"
                  :show-psychology-organization-link="
                    showPsychologyOrganizationLink
                  "
                  :withIcon="true"
                />
              </div>

              <div
                :class="{
                  'col-6 col-sm-6 col-md-6 col-lg-6':
                    item.clientSessionType == 'Session' && showTherapistPrifile,
                  'col ':
                    item.clientSessionType == 'Workshop' ||
                    !showTherapistPrifile,
                }"
              >
                <div>
                  <span class="d-block">
                    <b
                      v-if="
                        item.clientSessionType == 'Workshop' ||
                        !showTherapistPrifile
                      "
                      >{{ item.therapist }}
                    </b>
                    <span
                      v-if="
                        item.clientSessionType == 'Workshop' ||
                        !showTherapistPrifile
                      "
                      class="smaller"
                    >
                      ({{ item.therapyType }})</span
                    >
                    <!-- PschologyOrganizationLink -->
                    <therapist-pschology-organication-link
                      :showPsychologyOrganizationLink="
                        !showTherapistPrifile && showPsychologyOrganizationLink
                      "
                      :psychologyOrganizationLink="
                        item.pschologyOrganizationLink
                      "
                      v-if="item.clientSessionType == 'Session'"
                    ></therapist-pschology-organication-link>
                  </span>
                  <span class="d-block smaller fw-bold">
                    <span
                      v-if="
                        item.clientSessionType == 'Session' &&
                        showTherapistPrifile
                      "
                      >{{ item.therapyType }} -</span
                    >
                    {{ item.sessionType }}
                    <span
                      v-if="item.discountPercent"
                      class="fs10px text-success"
                    >
                      (کد تخفیف)</span
                    >

                    <span
                      v-if="
                        item.clientSessionType == 'Workshop' &&
                        item.sessionTypeID == 2
                      "
                      ><a :href="item.pschologyOrganizationLink" target="_blank"
                        >(
                        <svg
                          width="16px"
                          height="16px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-person-video3"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M14 9.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6 5.7c0 .8.8.8.8.8h6.4s.8 0 .8-.8-.8-3.2-4-3.2-4 2.4-4 3.2Z"
                          ></path>
                          <path
                            d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5.243c.122-.326.295-.668.526-1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7.81c.353.23.656.496.91.783.059-.187.09-.386.09-.593V4a2 2 0 0 0-2-2H2Z"
                          ></path>
                        </svg>
                        لینک تماس )</a
                      ></span
                    >
                  </span>
                  <span class="d-block smaller fw-bold">
                    <span
                      :class="{
                        'text-danger': item.holdingStatusID != 4,
                        'text-success': item.holdingStatusID == 4,
                      }"
                      >{{ item.holdingStatus }}</span
                    >
                  </span>

                  <span class="d-block smaller" v-if="item.address">
                    <span> <b>آدرس: </b>{{ item.address }}</span>
                  </span>

                  <!-- y
                    -->
                </div>
              </div>

              <div
                class="col-3 col-sm-3 col-md-3 col-lg-4 text-start pt-1 px-1-xs"
              >
                <div
                  class="float-end small position-relative mt-1 dropend"
                  v-if="item.isCancelable || item.isMoveable"
                >
                  <a
                    href="#"
                    class="text-dark text-decoration-none"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                  >
                    <i class="fi fi-dots-vertical-full m-0"></i>
                  </a>

                  <ul
                    class="dropdown-menu dropdown-menu-clean border-0 p-1 rounded"
                    style=""
                  >
                    <li class="dropdown-item">
                      <a
                        href="#"
                        class="text-muted small py-2 d-block"
                        v-if="item.isCancelable"
                        @click="cancelSessionButtonClick(item.id)"
                      >
                        <svg
                          width="18px"
                          height="18px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-trash-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                          ></path>
                        </svg>
                        لغو جلسه
                      </a>
                    </li>
                    <li class="dropdown-item">
                      <a
                        href="#"
                        class="text-muted py-2 d-block small"
                        v-if="item.isMoveable"
                        @click="moveSession(item)"
                      >
                        <svg
                          width="18px"
                          height="18px"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          class="bi bi-arrow-left-right"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                          ></path>
                        </svg>
                        جابجایی جلسه</a
                      >
                    </li>
                  </ul>
                </div>
                <span
                  class="text-muted smaller d-block text-center-xs"
                  dir="ltr"
                  style="clear: both"
                >
                  {{ getPersianDate(item.date) }}
                  <span v-if="isOverseas()">
                    |
                    <small class="gregorianDateClass"
                      >{{ getGregorianDate(item.date) }}
                    </small></span
                  >
                </span>

                <span
                  class="text-muted smaller d-block text-center-xs"
                  dir="ltr"
                  >{{ item.fromTime.toString().substr(0, 5) }} -
                  {{ item.toTime.toString().substr(0, 5) }}</span
                >
                <!-- :class="{ 'ms-3': item.isCancelable || item.isMoveable }" -->
                <span class="text-muted smaller d-block text-center-xs"
                  ><span :class="{ 'text-success': item.discountPercent }"
                    >{{ getThousand(item.price) }} {{ item.currencyType }}
                  </span>
                </span>

                <div class="mt-2 text-center-xs">
                  <button
                    type="button"
                    class="btn btn-sm btn-blueSite text-light rounded p-2 smaller p-1-xs"
                    @click="moveSession(item)"
                    v-if="item.isMoveable"
                  >
                    <svg
                      width="18px"
                      height="18px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-arrow-left-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                      ></path>
                    </svg>
                    <span class="d-lg-inline d-md-none d-sm-none d-xs-none"
                      >جابجایی</span
                    >
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger rounded p-2 smaller me-1 p-1-xs"
                    v-if="item.isCancelable"
                    @click="cancelSessionButtonClick(item.id)"
                  >
                    <svg
                      width="18px"
                      height="18px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-trash-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"
                      ></path>
                    </svg>

                    <span class="d-lg-inline d-md-none d-sm-none d-xs-none">
                      لغو
                    </span>
                  </button>

                  <a
                    :href="'/panel/workshopView/' + item.workshopGroupTherapyID"
                    type="button"
                    class="btn btn-sm btn-blueSite text-light rounded p-2 smaller p-1-xs"
                    v-if="
                      item.clientSessionType == 'Workshop' &&
                      item.workshopGroupTherapyID != 0 &&
                      item.workshopPaymentType == 2
                    "
                  >
                    <svg
                      width="18px"
                      height="18px"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="currentColor"
                      class="bi bi-reply-all-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M8.021 11.9 3.453 8.62a.719.719 0 0 1 0-1.238L8.021 4.1a.716.716 0 0 1 1.079.619V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z"
                      ></path>
                      <path
                        d="M5.232 4.293a.5.5 0 0 1-.106.7L1.114 7.945a.5.5 0 0 1-.042.028.147.147 0 0 0 0 .252.503.503 0 0 1 .042.028l4.012 2.954a.5.5 0 1 1-.593.805L.539 9.073a1.147 1.147 0 0 1 0-1.946l3.994-2.94a.5.5 0 0 1 .699.106z"
                      ></path>
                    </svg>

                    <span class="d-lg-inline"> تمدید </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
          v-if="sessionList.length == 0"
        >
          <div class="card-body d-flex justify-content-between">
            <div class="w-100 pt-1 text-center">
              <strong class="d-block fs-6 fw-medium">
                جلسه ای وجود ندارد</strong
              >
            </div>
          </div>
        </div>
        <div class="text-center my-2">
          <button
            type="button"
            class="btn p-1 btn-sm text-dark btn-warning float-start"
            @click="showInformationModal"
          >
            راهنما
          </button>
          <button
            class="btn btn-soft btn-light btn-sm text-black float-end"
            @click="moreSessionClick"
            v-if="hasMoreRecord"
          >
            <i class="fi fi-plus"></i>
            <span>نمایش بیشتر</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
// import { useRoute } from 'vue-router';
import axios from 'axios';
import { Modal } from 'bootstrap';
import { isMobile } from 'mobile-device-detect';
import ValidationSummery from '../../../../components/form/errorBox/ValidationSummery.vue';
import TherapistProfile from '../../../../components/data/therapistProfile/TherapistProfile.vue';
import TherapistPschologyOrganicationLink from '../../../../components/data/therapistPschologyOrganicationLink/TherapistPschologyOrganicationLink.vue';

export default {
  components: {
    LoadingSpinner,
    ValidationSummery,
    TherapistProfile,
    TherapistPschologyOrganicationLink,
  },
  inject: ['WalletList', 'RefreshWalletList'],
  data() {
    return {
      isMobile: isMobile,
      hasMoreRecord: false,
      personID: 0,
      modalConfirmHasError: false,
      modalError: [],
      modalMessage: '',
      modalTitle: '',
      operationConfirmation: '',
      sessionConfirmModal: new Object(),
      informationModal: new Object(),
      sessionList: [],
      showTherapistPrifile: true,
      showPsychologyOrganizationLink: true,
      searchData: {
        personID: 0,
        recordCount: 9,
      },
      entity: {
        id: 0,
        date: null,
        fromTime: null,
        toTime: null,
        sessionTypeID: 0,
        therapyTypeID: 0,
        therapistID: 0,
        holdingStatusID: 0,
        isEmergency: false,
        sessionType: null,
        therapyType: null,
        holdingStatus: null,
        therapist: null,
        pschologyOrganizationLink: null,
        price: 0,
        currencyType: null,
        address: null,
        isCancelable: null,
        isMoveable: null,
        discountCode: null,
        discountPercent: null,
        currencyTypeID: 0,
      },
      cancelationEntity: {
        id: 0,
        holdingStatusID: 7,
        holdingDescription: 'توسط مراجع لغو شد',
      },
    };
  },
  methods: {
    showInformationModal() {
      this.informationModal.show();
    },
    closeInformationModal() {
      this.informationModal.hide();
    },
    goToEmergancySession() {
      this.$router.push({
        name: 'emergencySessionTab',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    showEmergencyTooltip(event) {
      event.stopPropagation();
    },
    async getSessions() {
      let that = this;
      this.$refs.spinner.show();
      await axios
        .post('/Basic/Client/GetClientSessions/', that.searchData)
        .then((response) => {
          that.sessionList = response.data.sessionData;
          that.hasMoreRecord =
            response.data.allRecourdCount > response.data.sessionData.length;
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
            if (errorMessages && errorMessages.length > 0) return;
          }
          this.$refs.notification.show({
            type: 'error',
            title: `دریافت داده های جلسات با خطا مواجه شد`,
          });
        })
        .finally(() => {
          this.$refs.spinner.hide();
        });
    },
    async refreshButtonClick() {
      await this.getSessions();
    },
    getGregorianDate(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    getGregorianDateTime(date) {
      // eslint-disable-next-line
      return getGregorianDateTime(date);
    },
    getPersianDate(date) {
      /* eslint-disable */
      return new persianDate(new Date(date)).format('L');
    },
    async moreSessionClick() {
      this.searchData.recordCount += 9;
      await this.getSessions();
    },
    getThousand(balance) {
      /* eslint-disable */
      return thousandSeprator(balance);
    },
    cancelSessionButtonClick(id) {
      this.cancelationEntity.id = id;
      this.operationConfirmation = 'cancelSession';
      this.modalMessage = 'آیا از لغو جلسه انتخاب شده اطمینان دارید؟';
      this.modalTitle = 'لغو جلسه';
      this.sessionConfirmModal.show();
    },
    moveSession(session) {
      this.entity = session;
      this.operationConfirmation = 'moveSession';
      let oldReplacedSession = this.$store.getters.replacedSessionData;
      if (oldReplacedSession && oldReplacedSession?.id != this.entity.id) {
        this.modalMessage =
          'مراجع گرامی، شما در گذشته جلسه ای را برای جایگزینی انتخاب نموده اید. با تایید این پیام جلسه انتخاب شده جهت جابجایی با جلسه دیگر لحاظ خواهد شد.آیا از جابجایی جلسه انتخاب شده اطمینان دارید؟';
      } else {
        this.modalMessage = 'آیا از جابجایی جلسه انتخاب شده اطمینان دارید؟';
      }
      this.modalTitle = 'جابجایی جلسه';
      this.sessionConfirmModal.show();
    },
    emergencyButtonClick() {
      this.$router.push({ name: 'emergencySessionTab' });
    },
    async confirmedModal() {
      let that = this;
      if (this.operationConfirmation == 'cancelSession') {
        this.$refs.spinner.show();
        await axios
          .post('/CLC/Session/CancelSessionForSite', this.cancelationEntity)
          .then(async (response) => {
            if (!response.data.success) {
              this.modalConfirmHasError = true;
              let errorMessages = response.data.errors.map(
                (i) => i.errorMessage
              );
              this.modalError = errorMessages;
              return;
            }
            this.cancelModal();
            await that.getSessions();
            await that.RefreshWalletList();

            that.$refs.notification.show({
              type: 'success',
              title: `جلسه انتخاب شده با موفقیت لغو شد`,
            });
          })
          .catch((error) => {
            if (!error.response.data.success) {
              this.modalConfirmHasError = true;
              let errorMessages = error.response.data.errors.map(
                (i) => i.errorMessage
              );
              errorMessages.forEach((item) => {
                this.$refs.notification.show({
                  type: 'error',
                  title: item,
                });
              });
              this.modalError = errorMessages;
            }
          })
          .finally(() => {
            that.$refs.spinner.hide();
          });
      }
      if (that.operationConfirmation == 'moveSession') {
        that.$store.dispatch('setSessionForReplacement', that.entity);
        that.$router
          .push({
            name: 'selectTherapist',
            params: { id: that.$store.getters.userPersonID },
          })
          .then(() => {
            this.cancelModal();
          });
      }
    },
    cancelModal() {
      this.entity = new Object({
        id: 0,
      });
      this.cancelationEntity = new Object({
        id: 0,
        holdingStatusID: 7,
        holdingDescription: 'توسط مراجع لغو شد',
      });
      this.modalConfirmHasError = false;
      this.modalError = [];
      this.operationConfirmation = '';
      this.modalMessage = '';
      this.sessionConfirmModal.hide();
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
  },
  async mounted() {
    let that = this;
    // const route = useRoute();
    that.clientID = this.$store.getters.userPersonID;
    that.searchData.personID = this.$store.getters.userPersonID;
    that.sessionConfirmModal = new Modal(
      document.getElementById('sessionConfirmModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    that.informationModal = new Modal(
      document.getElementById('informationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );

    await that.getSessions();

    that.showTherapistPrifile =
      that.$store.getters.showTherapistPicture == 'true' ? true : false;
    that.showPsychologyOrganizationLink =
      that.$store.getters.showTherapistPsychologyOrganizationLink == 'true'
        ? true
        : false;

    /* eslint-disable */
    var tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
  },
};
</script>
<style scoped>
.btn-group-sm > .btn.rounded-circle,
.btn.btn-sm.rounded-circle {
  padding: 1.1rem !important;
}
</style>
<style>
.tooltip {
  --bs-tooltip-bg: #fad776;
  --bs-tooltip-color: #303030;
  --bs-tooltip-font-size: 0.775rem;
  font-family: Vazir;
}
</style>
